const TAG_FACET_NAME = "Tag";
const NEW_TAG_NAME = "What's New";
const BEST_SELLER_TAG_NAME = "Sale";

const Badges = {

create: (product, $gridItem) => {
    if ($gridItem.hasClass("inventory")) return;
  
    $gridItem.addClass("inventory");
    Badges.set(product, $gridItem);
  },
  
  set: (product, $gridItem) => {
    if($gridItem.find(".isp-custom-badge").length > 0) return;
    
    const tags = Badges.getProductTags(product);
    
    if(Badges.isNewEdition(tags)){
      $gridItem.prepend(`<span class="isp-custom-badge new-release">NEW</span>`);
    } else if(Badges.isOnSale(product)){
      $gridItem.prepend(`<span class="isp-custom-badge on-sale">SALE</span>`);
    } 
  },
  
  getProductTags: (product) => {
    const tags = product.att.find(x => x[0] === TAG_FACET_NAME);
    return tags ? tags[1] : [];
  },
  
  isNewEdition: (tags) => {
    return tags.includes(NEW_TAG_NAME);
  },
  
  isOnSale: (product) => {
    const originalPrice = parseFloat(product.p);
    const price = parseFloat(product.p_c);
  
    return price && originalPrice && originalPrice > 0 && price > 0 && price > originalPrice;
  },
  
  isBestSeller: (tags) => {
    return tags.includes(BEST_SELLER_TAG_NAME);
  },

};



var __isp_options = {
    isp_serp_disable_seo_schema: '1',
  	isp_serp_with_product_attributes: '1',
    isp_serp_callback: function() {
        $jquery_isp('.isp_grid_product').each(function() {
            var id = $jquery_isp(this).attr('product_id');
            var attributes = ISP_PRODUCTS[id].att;
            var variants = ISP_PRODUCTS[id].vra;
            const $gridItem = $(`.isp_grid_product[product_id="${id}"]`);
            const product = ISP_PRODUCTS[id];

            // add badges
            Badges.create(product, $gridItem);
            
            if (attributes) {
                if ($jquery_isp(this).find('.product-vendor').length === 0) {
                    var vendor = attributes.find(function (element) { return element[0] === "Vendor" }) ? ISP_PRODUCTS[id].att.find(function (element) { return element[0] === "Vendor" })[1][0] : "";
                    var vendorContainer = $jquery_isp('<div class="product-vendor"><span>' + vendor + '</span></div>');
                    $jquery_isp(this).find('.isp_product_info').prepend(vendorContainer);
                }
                if ($jquery_isp.inArray("preorder", attributes.find(function(element) { return element[0] == "Tag" })[1]) > -1) {
                    $jquery_isp(this).find('.isp_add_to_cart_btn').val("Pre-Order Now");
                } else {
                    $jquery_isp(this).find('.isp_add_to_cart_btn').val("Add To Bag");
                }
            } 
          
          	if (variants) {
                if (variants.length > 1) {
                    if (variants[0][1].find(function (element) { return element[0] == "Size" })) {
                        $jquery_isp(this).find('.isp_add_to_cart_btn').val("Choose your size");
                    } else if (variants[0][1].find(function (element) { return element[0] == "Shade" })) {
                        $jquery_isp(this).find('.isp_add_to_cart_btn').val("Choose your shade");
                    } else {
                        $jquery_isp(this).find('.isp_add_to_cart_btn').val("Add To Bag");
                    }
                } else {
                    $jquery_isp(this).find('.isp_add_to_cart_btn').val("Add To Bag");
                }
            } 
          	
          	if ($jquery_isp(this).find('.isp_sold_out_banner_container').length > 0) {
                if ($jquery_isp(this).find('.isp_add_to_cart_form').length === 0) {
                    var sign_up_button = $jquery_isp('<form class="isp_add_to_cart_form" action="' + ISP_PRODUCTS[id].u + '"><input type="submit" value="Sign Up To Waitlist" name="button" class="isp_add_to_cart_btn"></form>');
                    sign_up_button.insertAfter($jquery_isp(this).find('.isp_product_info'));
                } else {
                    $jquery_isp(this).find('.isp_add_to_cart_form').attr('action', ISP_PRODUCTS[id].u);
              	    $jquery_isp(this).find('.isp_add_to_cart_btn').val("Sign Up To Waitlist");
                }
            }
        });
      
        $jquery_isp("body").on('DOMSubtreeModified', ".cartCount", function () {
            $jquery_isp(".logo-right .dropdown-cart").load(location.href + " .logo-right .dropdown-cart > .has-items");
        });
    },
    isp_dropdown_callback: function(jquery_li_element_html, item_data) {
        if (jquery_li_element_html.find('.isp_product_dropdown_review').length === 0 && item_data.reviews_count) {
            var stars = item_data.review / 20;
            var starImage;
            var reviews = item_data.review;
            var reviewsContainer = $jquery('<div class="isp_product_dropdown_review" title="Average Score: ' + stars + ' | Total reviews: ' + item_data.reviews_count + '"></div>');
            jquery_li_element_html.find('.as_magento_product_section').append(reviewsContainer);
            for (var i = 1; i <= 5; i++) {
                if (reviews <= 0) {
                    starImage = $jquery('<img src="https://cdn.shopify.com/s/files/1/0018/5997/7334/t/27/assets/star_empty.png" title="empty"/>');
                    reviews = reviews - 20;
                    jquery_li_element_html.find('.isp_product_dropdown_review').append(starImage);
                } else if (reviews % 20 === 0) {
                    starImage = $jquery('<img src="https://cdn.shopify.com/s/files/1/0018/5997/7334/t/27/assets/star_full.png" title="full"/>');
                    reviews = reviews - 20;
                    jquery_li_element_html.find('.isp_product_dropdown_review').prepend(starImage);
                } else {
                    starImage = $jquery('<img src="https://cdn.shopify.com/s/files/1/0018/5997/7334/t/27/assets/star_half.png" title="half"/>');
                    reviews = reviews - (reviews % 20);
                    jquery_li_element_html.find('.isp_product_dropdown_review').prepend(starImage);
                }
            }
            jquery_li_element_html.find('.isp_product_dropdown_review').append('<span class="isp_product_dropdown_reviews_count">(' + item_data.reviews_count + ')</span>');
        }
        return jquery_li_element_html;
    },
    isp_serp_quickview_callback: function() {
        var id = $jquery_isp('.isp_quick_view_title').attr('product_id');
        var attributes = ISP_PRODUCTS[id].att;
        var variants = ISP_PRODUCTS[id].vra;
        
        if (attributes) {
            if ($jquery_isp.inArray("preorder", attributes.find(function(element) { return element[0] == "Tag" })[1]) > -1) {
                $jquery_isp('.isp_quick_view_add_to_cart_btn').val("Pre-Order Now");
            } else {
                $jquery_isp('.isp_quick_view_add_to_cart_btn').val("Add To Bag");
            }
        }
        
        if (variants) {
            if (variants[0][1].find(function(element) { return element[0] == "Shade" })) {
                var swatch_container = $jquery_isp('<div class="swatch clearfix" data-option-index="0" id="swatch-container"><div class="header">Shade - <span class=data-label></span></div></div>');
                swatch_container.insertAfter('.isp_quick_view_show_more');
                for (var i = 0; i < variants.length; i++) {
                    var variant_id = variants[i][0];
                    var variant_name = variants[i][1].find(function(element) { return element[0] == "Shade" })[1][0];
                    var variant_name_edited = variant_name.toLowerCase().replace(/ /g, '-').replace('.', '-');
                    var variant_sellable = variants[i][1].find(function(element) { return element[0] == "Sellable" })[1][0] ? 'available' : 'soldout';
                    var variant_swatch = $jquery_isp('<div data-value="' + variant_name.split('_')[0] + '" class="swatch-element color ' + variant_name_edited + ' ' + variant_sellable + '">' +
                                                        '<input id="swatch-0-' + variant_name_edited + '" type="radio" name="option-0" value="' + variant_name + '" data-wg-notranslate="manual">' +
                                                        '<label for="swatch-0-' + variant_name_edited + '" data-label="' + variant_name + '" style="background-image: url(//cdn.shopify.com/s/files/1/0018/5997/7334/files/' + variant_name.replace(/ /g, '_') + '.png)"></label>' +
                                                     '</div>');
                    if (variant_sellable == 'soldout') {
                        var variant_swatch_script = $jquery_isp('<script type="text/javascript">' +
                                                                    '$jquery_isp(".' + variant_name_edited + '").click(function() { ' +
                                                                        '$jquery_isp("#swatch-container span").text("' + variant_name.split("_")[0] + '"); ' +
                                                                        '$jquery_isp("#isp_selected_variant_id").val(' + variant_id + '); ' +
                                                                        '$jquery_isp(".isp_quick_view_add_to_cart_btn").val("Sign Up To Wishlist")' +
                                                                    '})' +
                                                                '</script>');
                    } else {
                        var variant_swatch_script = $jquery_isp('<script type="text/javascript">' +
                                                                    '$jquery_isp(".' + variant_name_edited + '").click(function() { ' +
                                                                        '$jquery_isp("#swatch-container span").text("' + variant_name.split("_")[0] + '"); ' +
                                                                        '$jquery_isp("#isp_selected_variant_id").val(' + variant_id + '); ' +
                                                                        '$jquery_isp(".isp_quick_view_add_to_cart_btn").val("Add To Bag")' +
                                                                    '})' +
                                                                '</script>');
                    }
                    variant_swatch.appendTo('#swatch-container');
                    variant_swatch_script.appendTo('#swatch-container');
                    if (variant_sellable == 'soldout') {
                        var soldout_image = $jquery_isp('<img class="crossed-out" src="//cdn.shopify.com/s/files/1/0018/5997/7334/t/19/assets/soldout.png">');
                        soldout_image.appendTo('.' + variant_name_edited + ' label');
                    }
                }
                $jquery_isp('.isp_quick_view_variant_select, .isp_quick_view_variant').remove();
                $jquery_isp('.swatch-element:first input').click();
            } else if (variants[0][1].find(function(element) { return element[0] == "Size" })) {
                var swatch_container = $jquery_isp('<div class="swatch clearfix" data-option-index="0" id="swatch-container"><div class="header">Size - <span class=data-label></span></div></div>');
                swatch_container.insertAfter('.isp_quick_view_show_more');
                for (var i = 0; i < variants.length; i++) {
                    var variant_id = variants[i][0];
                    var variant_name = variants[i][1].find(function(element) { return element[0] == "Size" })[1][0];
                  	if (variant_name.indexOf('% off)') > -1) { continue; }
                    var variant_name_edited = variant_name.toLowerCase().replace(/ /g, '-').replace('.', '-');
                    var variant_sellable = variants[i][1].find(function(element) { return element[0] == "Sellable" })[1][0] ? 'available' : 'soldout';
                    var variant_swatch = $jquery_isp('<div data-value="' + variant_name.split('_')[0] + '" class="swatch-element ' + variant_name_edited + ' ' + variant_sellable + '">' +
                                                     '<input id="swatch-0-' + variant_name_edited + '" type="radio" name="option-0" value="' + variant_name + '">' +
                                                     '<label for="swatch-0-' + variant_name_edited + '">' + variant_name_edited + '</label>' +
                                                     '</div>');
                    if (variant_sellable == 'soldout') {
                        var variant_swatch_script = $jquery_isp('<script type="text/javascript">' +
                                                                '$jquery_isp(".' + variant_name_edited + '").click(function() { ' +
                                                                '$jquery_isp("#swatch-container span").text("' + variant_name.split("_")[0] + '"); ' +
                                                                '$jquery_isp("#isp_selected_variant_id").val(' + variant_id + '); ' +
                                                                '$jquery_isp(".isp_quick_view_add_to_cart_btn").val("Sign Up To Wishlist")' +
                                                                '})' +
                                                                '</script>');
                    } else {
                        var variant_swatch_script = $jquery_isp('<script type="text/javascript">' +
                                                                '$jquery_isp(".' + variant_name_edited + '").click(function() { ' +
                                                                '$jquery_isp("#swatch-container span").text("' + variant_name.split("_")[0] + '"); ' +
                                                                '$jquery_isp("#isp_selected_variant_id").val(' + variant_id + '); ' +
                                                                '$jquery_isp(".isp_quick_view_add_to_cart_btn").val("Add To Bag");' +
                                                                '})' +
                                                                '</script>');
                    }
                    variant_swatch.appendTo('#swatch-container');
                    variant_swatch_script.appendTo('#swatch-container');
                    if (variant_sellable == 'soldout') {
                        var soldout_image = $jquery_isp('<img class="crossed-out" src="//cdn.shopify.com/s/files/1/0018/5997/7334/t/19/assets/soldout.png">');
                        soldout_image.appendTo('.' + variant_name_edited + ' label');
                    }
                }
                $jquery_isp('.isp_quick_view_variant_select, .isp_quick_view_variant').remove();
                $jquery_isp('.swatch-element:first input').click();
            }
        }
      
        $('.isp_quick_view_add_to_cart_btn').click(function(e) {
            if ($(this).val() === "Sign Up To Wishlist") {
                e.preventDefault();
                location.href = ISP_PRODUCTS[id].u;
            }
        });
    },
    isp_serp_raty_reviews_option: {
        starType: 'i',
        starHalf: 'spr-icon spr-icon-star-half-alt',
        starOff: 'spr-icon spr-icon-star-empty',
        starOn: 'spr-icon spr-icon-star'
    } 
};

var isp_related_options = {
  	MAX_SUGGEST: 4,
  	slider_options_slidesToShow: 4, 
  	with_product_attributes: true,
    isp_related_callback: function() {
        $jquery_isp('.isp_related_product').each(function() {
            var id = $jquery_isp(this).attr('isp_product_id');
            var attributes = ISP_RELATED_PRODUCTS[id].att;
            var variants = ISP_RELATED_PRODUCTS[id].vra;

            if (variants) {
                var var_id = variants[0][0];
                var add_to_cart = $jquery_isp('<form action="/cart/add" method="post" id="product-actions-' + id + '" enctype="multipart/form-data">' +
                                              '<input type="hidden" name="id" value="' + var_id + '">' +
                                              '<input class="btn add-to-cart-btn" type="submit" value="Add to Bag">' +
                                              '</form>');
                $jquery_isp(this).find('.isp_related_product_info').append(add_to_cart);
                if (!variants[0][1].find(function (element) { return element[0] == "Sellable" })[1][0]) {
                    $jquery_isp(this).find('.add-to-cart-btn').val("Sign Up To Waitlist");
                } else if (variants[0][1].find(function (element) { return element[0] == "Size" })) {
                    $jquery_isp(this).find('.add-to-cart-btn').val("Choose your size");
                } else if (variants[0][1].find(function (element) { return element[0] == "Shade" })) {
                    $jquery_isp(this).find('.add-to-cart-btn').val("Choose your shade");
                }
            }

            if (attributes) {
                var vendor = attributes.find(function (element) { return element[0] === "Vendor" }) ? attributes.find(function (element) { return element[0] === "Vendor" })[1][0] : "";
                var vendorContainer = $jquery_isp('<div class="product-vendor"><span>' + vendor + '</span></div>');
                $jquery_isp(this).find('.isp_related_product_info').prepend(vendorContainer);

                if ($jquery_isp.inArray("preorder", attributes.find(function(element) { return element[0] == "Tag" })[1]) > -1) {
                    $jquery_isp(this).find('.add-to-cart-btn').val("Pre-Order Now");
                }
            }

            $jquery_isp(this).find('.isp_product_price').addClass('price-box');
          
            if ($jquery_isp(this).find('.isp_product_review').length > 0) {
                $jquery_isp(this).find('.isp_product_review img').each(function(index) {
                    var src = $jquery_isp(this).attr('src');
                    var current_index = index + 1;
                    if (src.indexOf('full')) {
                        $jquery_isp(this).replaceWith('<i data-alt="' + current_index + '" class="spr-icon spr-icon-star"></i>');
                    } else if (src.indexOf('empty')) {
                        $jquery_isp(this).replaceWith('<i data-alt="' + current_index + '" class="spr-icon spr-icon-star-empty"></i>');
                    } else {
                        $jquery_isp(this).replaceWith('<i data-alt="' + current_index + '" class="spr-icon spr-icon-star-half"></i>');
                    }
                });
                $jquery_isp(this).find('.isp_product_reviews_count').text($jquery_isp(this).find('.isp_product_reviews_count').text().replace('(', '').replace(')', '') + ' Reviews');
            } else {
                var reviews = $jquery_isp('<div class="isp_product_review" id="isp_product_review_' + id + '" style="display: block;" title="Average Score: 0 | Total reviews: 0">' +
                    '<i data-alt="1" class="spr-icon spr-icon-star-empty"></i>&nbsp;' +
                    '<i data-alt="2" class="spr-icon spr-icon-star-empty"></i>&nbsp;' +
                    '<i data-alt="3" class="spr-icon spr-icon-star-empty"></i>&nbsp;' +
                    '<i data-alt="4" class="spr-icon spr-icon-star-empty"></i>&nbsp;' +
                    '<i data-alt="5" class="spr-icon spr-icon-star-empty"></i>' +
                    '<input name="score" type="hidden" value="0" readonly=""><span class="isp_product_reviews_count">0 Reviews</span></div>');
                reviews.insertAfter($jquery_isp(this).find('.isp_related_product_price'));
            }
        });
        $jquery_isp('.add-to-cart-btn').click(function(event) {
            event.preventDefault();
            if ($jquery_isp(this).val() !== "Add to Bag") {
                location.href = ISP_RELATED_PRODUCTS[$jquery_isp(this).parents('.isp_related_product').attr('isp_product_id')].u;
            } else if ($jquery_isp(this).attr('disabled') !== 'disabled') {
                var productItem = $jquery_isp(this).parents('.isp_related_product');
                var productId = $jquery_isp(productItem).attr('isp_product_id');
                productId = productId.match(/\d+/g);
                if (!window.ajax_cart) {
                    $jquery_isp('#product-actions-' + productId).submit();
                } else {
                    var variant_id = $jquery_isp('#product-actions-' + productId + ' select[name=id]').val();
                    if (!variant_id) {
                        variant_id = $jquery_isp('#product-actions-' + productId + ' input[name=id]').val();
                    }
                    var quantity = $jquery_isp('#product-actions-' + productId + ' input[name=quantity]').val();
                    if (!quantity) {
                        quantity = 1;
                    }
                    var title = $jquery_isp(productItem).find('.isp_related_product_name').text();
                    var image = $jquery_isp(productItem).find('.isp_related_product_image').attr('src');
                    $jquery_isp.ajax({
                        type: "post",
                        url: "/cart/add.js",
                        data: 'quantity=' + quantity + '&id=' + variant_id,
                        dataType: 'json',
                        beforeSend: function() {
                            $jquery_isp('.loading-modal').show();
                        },
                        success: function(msg) {
                            $jquery_isp('.loading-modal').hide();
                            $jquery_isp('.ajax-success-modal').find('.ajax-product-title').html(title);
                            $jquery_isp('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                            $jquery_isp('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
                            $jquery_isp('.ajax-success-modal').find('.btn-go-to-cart').show();
                            $jquery_isp('.ajax-success-modal').fadeIn(500);
                            setTimeout(function() {
                                $jquery_isp('.ajax-success-modal').fadeOut(500);
                            }, 5000);
                            Shopify.getCart(function(cart) {
                                doUpdateDropdownCart(cart);
                            });
                        },
                        error: function(xhr, text) {
                            $jquery_isp('.loading-modal').hide();
                            $jquery_isp('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                            $jquery_isp('.ajax-success-modal').fadeIn(500);
                            setTimeout(function() {
                                $jquery_isp('.ajax-success-modal').fadeOut(500);
                            }, 5000);
                        }
                    });
                }
            }
            return false;
        });
      
        function doUpdateDropdownCart(cart) {
            var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
            $jquery_isp('.cartCount').text(cart.item_count);
            $jquery_isp('.dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
            $jquery_isp('.dropdown-cart .mini-products-list').html('');
            if (cart.item_count > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    var item = template;
                    item = item.replace(/\{ID\}/g, cart.items[i].id);
                    item = item.replace(/\{URL\}/g, cart.items[i].url);
                    item = item.replace(/\{TITLE\}/g, cart.items[i].title.split('_')[0]);
                    item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                    item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
                    item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                    $jquery_isp('.dropdown-cart .mini-products-list').append(item);
                }
                $jquery_isp('.dropdown-cart .btn-remove').click(function(event) {
                    event.preventDefault();
                    var productId = $(this).parents('.item').attr('id');
                    productId = productId.match(/\d+/g);
                    Shopify.removeItem(productId, function(cart) {
                        doUpdateDropdownCart(cart)
                    });
                });
                if (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) {
                    Currency.convertAll(window.shop_currency, jQuery('.currencies').val(), '.dropdown-cart span.money', 'money_format');
                }
            }
            if ($jquery_isp('.dropdown-cart .mini-products-list').children().length > 0) {
                $jquery_isp('.dropdown-cart .no-items').hide();
                $jquery_isp('.dropdown-cart .has-items').show();
            } else {
                $jquery_isp('.dropdown-cart .has-items').hide();
                $jquery_isp('.dropdown-cart .no-items').show();
            }
        }
    }
};